import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {OrdnerEnum} from '../../../core/model/ordner.enum';
import {NachrichtAction} from './nachricht-action.enum';
import i18next from "i18next";
import {I18NextPipe} from "@kokos-i18next";

@Component({
    selector: 'pf-nachricht-action-buttons',
    standalone: true,
    imports: [I18NextPipe],
    templateUrl: './nachricht-action-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtActionButtonsComponent {

    @Input() nachrichtActions: NachrichtAction[] = [];
    @Input() nachrichtId: string;
    @Input() nachrichtFolder: OrdnerEnum;

    @Output() buttonClicked = new EventEmitter<NachrichtAction>();

    protected readonly nachrichtAction = NachrichtAction;
    protected readonly OrdnerEnum = OrdnerEnum;

    downloadTitle(): string {
       return i18next.t('message-actions.download-summary');
    }

    clickedButton(action: NachrichtAction, event: MouseEvent): void {
        event.preventDefault();
        this.buttonClicked.emit(action);
    }
}
